// 捷克语
import constant from '../../constants/lang/cs';
import newLang from '../newLang/cs';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Prosím nejdříve se přihlašte！',
        404: 'Žádná data',
        500: 'Systém je zaneprázdněn, zkuste to znovu později',
        504: 'Vypršel časový limit žádosti',
        ERR_NETWORK: 'Výjimka sítě',
        ERR_NETWORK_UPLOAD: 'Nahrávání se nezdařilo, zkuste jinou síť',
      },
    },
    title: '智能网联国际版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Indikátor světla',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Záznam',
        'feedback-create': 'Zpětná vazba',
        'feedback-supplement': 'Další zpětná vazba',
        'feedback-detail': 'Podrobnosti o zpětné vazbě',
        'feedback-result': 'Zpětná vazba',
        guide: 'Centrum nápovědy',
        'guide-restScreen': 'Pokyny k nastavení',
        'guide-overview': 'Přehled funkcí',
        'guide-account': 'O účtu',
        'guide-vehicle': 'O vozidle',
        'guide-meterSetting': 'Jak nastavit palubní desku',
        'guide-vehicleSetting': 'Jak nastavit vozidlo',
        'guide-findNavigation': 'Jak navigovat k vyhledání vozidla',
        'guide-vehicleNnavigation': 'Jak používat navigaci',
        'guide-cyclingRecord': 'O historii jízdy',
        'guide-vehicleExperience': 'Jak provést vlastní kontrolu vozidla',
        'guide-useSetting': 'Jak provést obecná nastavení APP',
        'guide-notice': 'Jak zobrazit a nastavit upozornění na zprávy',
        'guide-about': 'O aplikaci APP',
        help: 'Nápověda a zpětná vazba',
        'help-detail': 'Podrobnosti otázky',
        'myCar-unbinding': 'Použít rozvázání',
        'myCar-unbinding-result': 'Použít rozvázání',
      },
    },
    form: {
      cancel: 'Zrušit',
      confirm: 'Potvrdit',
      submit: 'Potvrdit',
      search: 'Vyhledávání',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protokol`,
      text1: '1.	Telematické služby',
      text2:
        'Společnost CFMOTO Powersports, Inc. (dále jen „ CFMOTO “ ) poskytuje telematické služby vozidla zákazníkovi, který si zakoupil vozidlo CFMOTO (dále jen „Zákazník“ ). Pro tyto služby využívá CFMOTO údaje zaznamenané Vozidlem o Vozidle a jeho jízdním chování v příslušném časovém období. Konkrétně se to týká následujících údajů:',
      text3: 'Údaje o chování uživatele při řízení : včetně zrychlení, zpomalení, rychlosti, zatáček, poslední doby jízdy a ujeté vzdálenosti .',
      text4:
        'Údaje o stavu vozidla: označují stav vozidla v reálném čase, včetně jízdního režimu, zbytkového paliva, okamžité spotřeby paliva, ujetých kilometrů, rychlostního stupně vozidla v reálném čase, rychlosti motoru, tlaku v pneumatikách, teploty pneumatik, údajů o napětí aktivace baterie , teplota chladicí kapaliny, stav elektronického zámku, verze softwaru inteligentního zařízení, síla signálu chytrých zařízení, aktuální nastavení palubní desky.',
      text5:
        'Data alarmu vozidla: data alarmu, která se mají odeslat, pokud určitá data překročí přednastavenou hodnotu, jako je teplota motoru, nadměrná rychlost, nadměrná doba jízdy, vysoká teplota chladicí kapaliny, abnormální pohyb vozidla, abnormální tlak v pneumatikách, vibrace, dumping, kolize atd . .',
      text6: 'Informace o poruše vozidla: odkazuje na chybové kódy hlášené každou vnitřní částí vozidla.',
      text7: 'Údaje o poloze vozidla: odkazují na konkrétní zeměpisné umístění vozidla.',
      text8: '1.1.	Poskytnutí ing Zákazník se službami souvisejícími s vozidlem prostřednictvím CFMOTO RIDE APP .',
      text9: '1.1.1.	Spotřebitelé mohou na dálku spravovat vozidla prostřednictvím CFMOTO RIDE APP (včetně zobrazení polohy vozidla, nastavení informací o vozidle a funkcí, dálkového ovládání stavu vozidla atd.).',
      text10: '1.1.2.	Poskytování plánování trasy během navigace, včetně výpočtu vzdálenosti mezi vozidly a pěší navigace za účelem vyhledání vozidla .',
      text11: '1.2.	Zasílání nezbytných oznámení Zákazníkovi na základě podmínek vozidla.',
      text12: '1.2.1.	CFMOTO ukončí upozornění Zákazníka na údržbu vozidla (např. na základě celkové vzdálenosti, kterou Zákazník ujel, času, kdy Zákazník vozidlo koupil, požadavků na čas nebo dojezdovou vzdálenost pro údržbu vozidla) .',
      text13: '1.2.2.	Na základě údajů o vozidle CFMOTO zašle Zákazníkovi upozornění na abnormální situaci; včetně analýzy dat OEM (v závislosti na modelu) pro zajištění péče o zákazníky a následné optimalizace vozidla .',
      text14: '1.3.	Podpora při analýze příčiny nehody, pokud Zákazník nahlásí vážnou nehodu Vozidla.',
      text15:
        '1.3.1.	V případě vážné nehody Vozidla, např. když se Vozidlo během jízdy převrátí nebo převrátí na bok, podpoří CFMOTO Zákazníka na požádání při objasnění, zda je nehoda způsobena závadou na Vozidlo nebo jinými okolnostmi. Požadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
      text16: '1.3.2.	Pokud to dostupné údaje umožňují, CFMOTO vyhodnotí údaje ve vztahu k příčině nehody a poskytne zákazníkovi odpovídající zprávu.',
      text17: '1.4.	Pomoc Zákazníkovi získat Vozidlo po ztrátě Vozidla .',
      text18: '1.4.1.	V případě ztráty Vozidla poskytne CFMOTO Zákazníkovi na požádání a pokud jsou k dispozici údaje o poloze Vozidla a další užitečné údaje o stavu Vozidla (jako je poloha poslední aktivace, aktuální stav vozidla atd.).',
      text19: '1.4.2.	Požadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
      text20: '1.5.	Hlášení poprodejních problémů .',
      text21: '1.5.1.	CFMOTO shromažďuje na dálku upozornění na chybové kódy zaslané Vozidlem v případě poruchy jeho součástí a poskytuje příslušné informace na žádost Zákazníka přímo Zákazníkovi.',
      text22: '1.5.2.	Požadavek musí být předložen společnosti CFMOTO zákazníkem prostřednictvím místního distributora / prodejního partnera uvedeného ve smlouvě o prodeji vozidla.',
      text23: '2.	Omezení a vyloučení služby',
      text24: '2.1.	Výslovně se poukazuje na to, že konstrukční nebo jiné technické změny na vozidle mohou omezit poskytování služeb nebo dokonce znemožnit, protože služby závisí na správném poskytnutí údajů o vozidle.',
      text25: '2.2.	V případě, že takové služby nemohou být poskytovány z důvodu výkonu jakýchkoli datových nebo telekomunikačních sítí třetích stran , je jakákoli odpovědnost společnosti CFMOTO vyloučena.',
      text26: '3.	Soukromí',
      text27: `vozidlem CFMOTO dodržovat platné předpisy o ochraně osobních údajů . Podmínky zásad ochrany osobních údajů C FMOTO jsou uvedeny v této CFMOTO RIDE APP. Jako doplněk k zásadám ochrany osobních údajů je jeho oznámení v souladu se zásadami ochrany osobních údajů . Zákazník si může pro některý obsah související se zpracováním dat, na který se nevztahuje toto oznámení, podívat na zásady ochrany osobních údajů .`,
      text28: '4.	Služby zákazníkům',
      text29:
        '4.1.	Zákazník může bez obav posílat otázky, komentáře nebo obavy týkající se ochrany osobních údajů na CFMOTORIDEAPP@cfmotousa.com nebo napsat na adresu: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Zákazník může také zavolat CFMOTO Customer Relations na čísle (888) 823-6686. ',
      text30: '5.	R revize',
      text31: '5.1.	CFMOTO si vyhrazuje právo toto upozornění kdykoli změnit, ale revize zveřejníme na CFMOTO RIDE Aplikujte a/nebo poskytněte upozornění, než tak učiníme podle potřeby.',
    },
    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Nová nastavení se projeví během 1-3 minut po zapnutí vozidla, ujistěte se, že je vozidlo v dobré pozici signálu',
      setSuccess: 'Úspěšně nastaveno',
      sure: 'Jistý',
      confirm: 'Potvrdit',
      cancel: 'Zrušit',
      cContent: 'Nastavení ještě nebylo uloženo, chcete je uložit?',
      save: 'Uložit nastavení',
      introduce1: 'V blízkosti pokynů pro automatické odemykání',
      introduce2: 'pokyny pro automatické vypnutí',
      introduce3: 'Pokyny pro automatické probuzení',
      introduce4: 'Zpožděné zhasnutí světel',
      content1: {
        msg1: 'Po zapnutí funkce mobil zapne Bluetooth a APP běží dál. Při přiblížení k vozidlu z dálky do blízkosti lze vozidlo automaticky odemknout a zapnout.',
        msg2: 'Pokud se normálně neodemkne a nezapne, odemkněte a zapněte stisknutím tlačítka napájení vozidla',
        msg3: 'Automatické odemykání blízkosti bude spuštěno pouze jednou před odpojením bluetooth',
      },
      content2: {
        msg1: 'Po zapnutí funkce se vozidlo automaticky vypne po 5 sekundách po třech podmínkách vypnutého vozidla, rychlost vozidla je 0 a chrám je upuštěn',
        msg2: 'Spuštění vozidla během období automatického vypnutí není rychlost vozidla 0 nebo odložení chrámu zruší automatické vypnutí',
      },
      content3: {
        msg1: 'Po zapnutí funkce, při vypnutí vozidla se mobilní telefon zapne Bluetooth a APP běží dál nebo nese fyzický klíč. Při přiblížení k vozidlu z dálky do blízkosti blikají světla vozidla, aby přivítali hosty',
        msg2: 'Aby se zabránilo častým spouštěčům ve ztrátě výkonu vozidla, po spuštění uvítací funkce dvakrát do 30 sekund se obnoví až o 30 minut později',
      },
      content4: {
        msg1: 'Po zapnutí funkce se automaticky rozsvítí dálková a potkávací světla na 10 sekund po vypnutí vozidla',
      },
    },
    feedback: {
      label: {
        type: 'Typ zpětné vazby (jeden výběr)',
        content: 'Popis problému',
        fileList: 'Nahrajte prosím obrázek',
        fileList2: '(Maximálně 4 obrázky / 1 video)',
        feedbackCreate: 'Klikněte na zpětnou vazbu',
        feedbackSupplement: 'Další zpětná vazba',
        backHome: 'Zpět na domovskou stránku',
        vehicle: 'přidružené vozidlo',
        selectVehicle: 'vybrat vozidlo',
      },
      placeholder: {
        'content.bug': 'Podrobně popište čas výskytu, verzi aplikace APP, model mobilního telefonu, způsob ovládání a popis problému, abyste mohli problém rychle lokalizovat a vyřešit!',
        'content.suggest': 'Vítejte na cenné návrhy, budeme vážně zvážit vaše nápady',
        'content.vehicle': 'Popište prosím, kdy se to stalo, jak se to stalo a v čem je problém.',
        'content.other': 'Popište prosím, kdy se to stalo, jak se to stalo a v čem je problém.',
        'content.supplement': 'Přidejte prosím popis problému',
        vehicle: 'Vyberte prosím vozidlo',
      },
      rules: {
        'type.required': 'Vyberte typ zpětné vazby',
        'content.required': 'Zadejte prosím popis svého problému',
        'fileList.uploading': 'Nahrávání, počkejte prosím',
        'fileList.maxSize': 'Nahraný soubor je příliš velký',
        'fileList.overType': 'Nepodporovaný formát',
        'fileList.maxCount': 'Počet odeslaných souborů překračuje limit',
        'fileList.acceptImageVideo': 'Při výběru obrázků nelze vybrat video',
        'vehicle.required': 'Vyberte prosím vozidlo',
      },
      message: {
        empty: 'V současné době nejsou k dispozici žádné záznamy o zpětné vazbě.~',
        finish: 'Odpověď',
        loading: 'Načítání',
        uploadFailed: 'Nahrávání selhalo',
        tip: 'Z důvodu ochrany vašeho účtu zde prosím nezadávejte citlivé osobní údaje, jako jsou hesla k účtům apod. ',
        feedbackSuccess: 'Zpětná vazba přijata',
        'submit.error': 'Zpětná vazba selhala',
        'submit.success': 'Zpětná vazba přijata',
      },
    },
    guide: {
      label: { giveFeedback: 'Nevyřešeno, chci dát zpětnou vazbu' },
    },
    help: {
      label: {
        history: 'Vyhledávání záznamů',
        cancel: 'Zrušit',
        yes: 'Ano',
        no: 'Ne',
        unresolved: 'Stále nemůžete vyřešit? Klikněte',
        submitFeedback: 'Odeslat zpětnou vazbu',
      },
      placeholder: {
        search: 'Vyhledávání',
        'content.required': 'Zadejte klíčové slovo',
      },
      message: {
        empty: 'Žádný související obsah',
        empty2: 'Navrhněte změnu klíčových slov popř',
        finish: 'Odpověď',
        historyDelete: 'Smazat všechny záznamy vyhledávání?',
        isHelpful: 'pomáhá to?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Vaše celé jméno',
        email: 'E-mailová adresa',
        phone: 'Telefonní číslo',
        areaCode: 'Kód země',
        identity: 'Identifikace',
        drivingLicense: 'Potvrzení o registraci vozidla.',
        backHome: 'Zpět na domovskou stránku',
        areaCodeTitle: 'Kód země',
        latterTitle: 'Oznámení',
        agree: 'Potvrdit',
        disagree: 'Nesouhlasím',
        agreeCheckLabel: ' Přečetl jsem a souhlasím',
        agreeCheckTitle: 'Pokyny pro podání žádosti o rozvázání vozidla',
      },
      placeholder: {
        vin: 'Zadejte prosím VIN',
        realName: 'Zadejte prosím své skutečné jméno',
        email: 'prosím zadejte svou e-mailovou adresu',
        phone: 'Zadejte prosím své telefonní číslo',
        identity: 'Hlavní stránka průkazu totožnosti, řidičského průkazu nebo pasu obsahující osobní identifikační informace.',
        drivingLicense: 'Hlavní stránka potvrzení o registraci vozidla s uvedeným jménem vlastníka a VIN.',
      },
      rules: {
        'agree.required': 'Prosím, přečtěte si a souhlaste',
        'vin.required': 'Zadejte prosím VIN',
        'vin.pattern': 'Chybné VIN, prosím zkontrolujte.',
        'realName.required': 'Zadejte prosím své skutečné jméno',
        'email.required': 'prosím zadejte svou e-mailovou adresu',
        'email.pattern': 'Nesprávný formát e-mailové adresy, prosím zkontrolujte.',
        'phone.required': 'Zadejte prosím své telefonní číslo',
        'phone.pattern': 'Chyba ve formátu telefonního čísla, zkontrolujte prosím',
        'fileList.maxCount': 'Počet odeslaných souborů překračuje limit',
        'fileList.uploading': 'Nahrávání, počkejte prosím',
      },
      message: {
        imgUploadFailed: 'Nahrání obrázku se nezdařilo',
        securityMessage: 'Výše uvedené informace slouží pouze k ověření identity, CFMOTO chrání vaše informace.',
        resultMessage: 'Aplikační materiály ověříme co nejdříve, věnujte prosím pozornost oznamovací liště nebo centru zpráv APP včas.',
        loading: 'načítání',
      },
    },
  },
};
